module.exports = __webpack_public_path__ + "static/media/xray2.1f567a62.jpg";